import { values } from "../theme/constants";

const transformVariableToInt = (variable) => {
    const value = variable.replace("px", "");
    return parseInt(value);
};

const MOBILE_WIDTH = transformVariableToInt(values.VIEW_PORT.MOBILE);
const TABLET_WIDTH = transformVariableToInt(values.VIEW_PORT.TABLET);
const LAPTOP_WIDTH = transformVariableToInt(values.VIEW_PORT.LAPTOP);
const DESKTOP_WIDTH = transformVariableToInt(values.VIEW_PORT.DESKTOP);

export { MOBILE_WIDTH, TABLET_WIDTH, DESKTOP_WIDTH, LAPTOP_WIDTH };
